import api from './axios';
import { BusinessesResponse } from './types';

const businessApi = {
    getBusinesses: async (): Promise<BusinessesResponse> => {
        const response = await api.get('/businesses');
        return response.data;
    },
};

export default businessApi;

